/*
 * @description:
 * @author: wolfgun
 * @Date: 2020-11-26 23:11:28
 */
import request from '@/utils/request'
import { ADMIN_SERVICE_URL } from '@/utils/constant'
export function list(queryParams) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dictionaries`,
    method: 'get',
    params: queryParams
  })
}

export function listByTypeCode(typeCode) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dictionaries`,
    method: 'get',
    params: { 'typeCode': typeCode }
  })
}

export function detail(id) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dictionaries/` + id,
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dictionaries`,
    method: 'post',
    data: data
  })
}

export function update(id, data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dictionaries/` + id,
    method: 'put',
    data: data
  })
}

export function del(ids) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dictionaries`,
    method: 'delete',
    params: { ids: ids }
  })
}

export function patch(id, data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/dictionaries/` + id,
    method: 'patch',
    data: data
  })
}
